import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalexperience-card',
  templateUrl: './helpbutton-reports-totalexperience-card.component.html',
  styleUrls: ['./helpbutton-reports-totalexperience-card.component.scss']
})
export class HelpbuttonReportsTotalexperienceCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
